export default __webpack_public_path__ + "static/media/exchange.0259c081.jpeg";